import { useCallback, useEffect, useState } from "react"
// context
// components
import Button from "shared/components/Button"
// styles
import { SText, STitle } from "../../styles"
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
import { useTranslation } from "react-i18next"
// types
// utils

const UserInactivity = (modalData: {
  secondsLeft: number
  closeModal: () => void
  getRemainingTime: () => number
  activate: () => boolean
}) => {
  const { t } = useTranslation()
  const { handleRemoveAuthToken } = useAuthenticationContext()

  const { secondsLeft, closeModal, activate } = modalData

  const [remaining, setRemaining] = useState(secondsLeft)

  const handleButtonClick = useCallback(() => {
    activate()
    closeModal()
  }, [closeModal])

  useEffect(() => {
    if (remaining <= 0) {
      handleRemoveAuthToken()
      return
    }

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [remaining])

  return (
    <div>
      <STitle>{t("onboarding:inactivityModal:title")}</STitle>
      <SText variant="h5">
        {t("onboarding:inactivityModal:textFirstPart")}
        {`${remaining.toString().length === 1 ? `0${remaining}` : remaining} ${t(
          "onboarding:inactivityModal:textSecondPart"
        )}`}
      </SText>
      <Button type="button" color="secondary" fullWidth variant="contained" onClick={handleButtonClick}>
        {t("onboarding:inactivityModal:logoutButtonText")}
      </Button>
    </div>
  )
}

export default UserInactivity
